
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.724 18.889a.56.56 0 01.481.273.56.56 0 010 .565.546.546 0 01-.48.273h-9.45a.56.56 0 01-.48-.273.56.56 0 010-.565.546.546 0 01.48-.273h9.45zM22.34 4a.66.66 0 01.66.66v12.68a.66.66 0 01-.66.66H1.66a.66.66 0 01-.66-.66V4.66A.66.66 0 011.66 4h20.68zM7.5 7.75H6v4.5l3-.001v2.001h1.5v-2.001l1 .001v-1.5l-1-.001V7.75H9v2.999H7.5V7.75zm6.75 0h-1.5v6.5h1.5v-2.5h.858l1.5 2.5h1.734L16.4 11l1.942-3.25h-1.734l-1.5 2.5h-.858v-2.5z","id":"🎨-Color","fill":"#000"}})])
          )
        }
      }
    